import AlarmConfig from './AlarmConfig'

export default AlarmConfig
